export default "__VITE_ASSET__BuGIHL26__"